var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Avatar, Box, Card, CardContent, Divider, Stack, Typography, } from "@mui/material";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { TeamColorsCircle } from "../teams/TeamColors";
var ROUND_LABELS = {
    1: "Final",
    2: "Semi-Finals",
    3: "Quarter-Finals",
    4: "Round of 16",
    5: "Round of 32",
};
var getRoundLabel = function (playoffRound) { var _a; return (_a = ROUND_LABELS[playoffRound]) !== null && _a !== void 0 ? _a : "Round of ".concat(Math.pow(2, playoffRound)); };
var MATCH_HEIGHT = 72;
var CONNECTOR_WIDTH = 24;
var ROUND_COL_WIDTH = 200;
var TeamRow = function (_a) {
    var name = _a.name, score = _a.score, isWinner = _a.isWinner, isLoser = _a.isLoser, isTbd = _a.isTbd, primaryColour = _a.primaryColour, secondaryColour = _a.secondaryColour;
    return (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: { px: 1, py: 0.5, minHeight: 32 }, children: [_jsx(Avatar, { sx: __assign({ width: 24, height: 24, bgcolor: isTbd ? "action.disabledBackground" : "transparent", overflow: "hidden", p: 0, fontSize: 12 }, (isLoser && { opacity: 0.45 })), children: isTbd ? ("?") : (_jsx(TeamColorsCircle, { color1: primaryColour || "#6c757d", color2: secondaryColour || "#adb5bd" })) }), _jsx(Typography, { variant: "body2", noWrap: true, sx: {
                    flex: 1,
                    fontWeight: isWinner ? 700 : 400,
                    color: isTbd
                        ? "text.disabled"
                        : isLoser
                            ? "text.secondary"
                            : "text.primary",
                }, children: name }), score != null && (_jsx(Typography, { variant: "body2", sx: {
                    fontWeight: isWinner ? 700 : 400,
                    minWidth: 16,
                    textAlign: "right",
                    color: isLoser ? "text.secondary" : "text.primary",
                }, children: score }))] }));
};
export var PlayoffBracket = function (_a) {
    var matches = _a.matches, seasonId = _a.seasonId, leagueId = _a.leagueId;
    var _b = useMemo(function () {
        var _a;
        var byRound = new Map();
        matches.forEach(function (m) {
            var _a;
            if (m.playoffRound == null)
                return;
            var existing = (_a = byRound.get(m.playoffRound)) !== null && _a !== void 0 ? _a : [];
            existing.push(m);
            byRound.set(m.playoffRound, existing);
        });
        if (byRound.size === 0)
            return { columns: [], maxRound: 0, winner: null, runnerUp: null };
        var maxR = Math.max.apply(Math, __spreadArray([], __read(byRound.keys()), false));
        // Build columns from highest round (earliest stage) down to Final (1)
        var cols = [];
        for (var r = maxR; r >= 1; r--) {
            var realMatches = (_a = byRound.get(r)) !== null && _a !== void 0 ? _a : [];
            var expectedCount = Math.pow(2, r - 1);
            var matchCards = realMatches.map(function (m) {
                var _a, _b;
                return ({
                    id: m.id,
                    homeTeam: m.homeTeam,
                    awayTeam: m.awayTeam,
                    homeScore: (_a = m.leagueMatchResult) === null || _a === void 0 ? void 0 : _a.homeTeamScore,
                    awayScore: (_b = m.leagueMatchResult) === null || _b === void 0 ? void 0 : _b.awayTeamScore,
                    isCompleted: m.status === "completed",
                    isTbd: false,
                });
            });
            // Fill remaining slots with TBD
            for (var i = matchCards.length; i < expectedCount; i++) {
                matchCards.push({
                    homeTeam: { name: "TBD" },
                    awayTeam: { name: "TBD" },
                    isCompleted: false,
                    isTbd: true,
                });
            }
            cols.push({ round: r, matches: matchCards });
        }
        // Determine winner/runner-up from the final
        var w = null;
        var ru = null;
        var finalMatches = byRound.get(1);
        if ((finalMatches === null || finalMatches === void 0 ? void 0 : finalMatches.length) === 1 && finalMatches[0]) {
            var f = finalMatches[0];
            if (f.status === "completed" && f.leagueMatchResult) {
                var hs = f.leagueMatchResult.homeTeamScore;
                var as_ = f.leagueMatchResult.awayTeamScore;
                if (hs > as_) {
                    w = f.homeTeam;
                    ru = f.awayTeam;
                }
                else if (as_ > hs) {
                    w = f.awayTeam;
                    ru = f.homeTeam;
                }
            }
        }
        return { columns: cols, maxRound: maxR, winner: w, runnerUp: ru };
    }, [matches]), columns = _b.columns, maxRound = _b.maxRound, winner = _b.winner, runnerUp = _b.runnerUp;
    if (columns.length === 0)
        return null;
    var totalRounds = columns.length;
    var bracketHeight = Math.pow(2, maxRound - 1) * (MATCH_HEIGHT + 16);
    return (_jsxs(Stack, { spacing: 2, children: [winner && (_jsx(Card, { variant: "outlined", sx: { borderColor: "warning.main" }, children: _jsx(CardContent, { sx: { py: 1.5, "&:last-child": { pb: 1.5 } }, children: _jsxs(Stack, { spacing: 1, children: [_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, justifyContent: "center", children: [_jsx(EmojiEventsIcon, { sx: { color: "warning.main" } }), _jsx(Typography, { variant: "subtitle1", fontWeight: 700, children: "Winner" })] }), _jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, justifyContent: "center", children: [_jsx(Avatar, { sx: {
                                            width: 28,
                                            height: 28,
                                            bgcolor: "transparent",
                                            overflow: "hidden",
                                            p: 0,
                                        }, children: _jsx(TeamColorsCircle, { color1: winner.primaryColour || "#6c757d", color2: winner.secondaryColour || "#adb5bd" }) }), _jsx(Typography, { variant: "body1", fontWeight: 600, children: winner.name })] }), runnerUp && (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, justifyContent: "center", children: [_jsx(Avatar, { sx: {
                                            width: 24,
                                            height: 24,
                                            bgcolor: "transparent",
                                            overflow: "hidden",
                                            p: 0,
                                        }, children: _jsx(TeamColorsCircle, { color1: runnerUp.primaryColour || "#6c757d", color2: runnerUp.secondaryColour || "#adb5bd" }) }), _jsxs(Typography, { variant: "body2", color: "text.secondary", children: ["Runner-up: ", runnerUp.name] })] }))] }) }) })), _jsx(Box, { sx: { overflowX: "auto" }, children: _jsx(Box, { sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        minWidth: totalRounds * (ROUND_COL_WIDTH + CONNECTOR_WIDTH) -
                            CONNECTOR_WIDTH,
                        py: 1,
                        px: 0.5,
                    }, children: columns.map(function (col, colIdx) { return (_jsxs(React.Fragment, { children: [_jsxs(Box, { sx: { width: ROUND_COL_WIDTH, flexShrink: 0 }, children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", textAlign: "center", sx: { fontWeight: 600, mb: 1 }, children: getRoundLabel(col.round) }), _jsx(Stack, { spacing: 0, justifyContent: "space-around", sx: { height: bracketHeight }, children: col.matches.map(function (match, matchIdx) {
                                            var homeWins = match.isCompleted &&
                                                match.homeScore != null &&
                                                match.awayScore != null &&
                                                match.homeScore > match.awayScore;
                                            var awayWins = match.isCompleted &&
                                                match.homeScore != null &&
                                                match.awayScore != null &&
                                                match.awayScore > match.homeScore;
                                            var card = (_jsx(Card, { variant: "outlined", sx: __assign(__assign({ height: MATCH_HEIGHT }, (!match.isTbd && {
                                                    "&:hover": { borderColor: "primary.main" },
                                                    transition: "border-color 0.2s",
                                                })), (match.isTbd && {
                                                    borderStyle: "dashed",
                                                    opacity: 0.5,
                                                })), children: _jsxs(CardContent, { sx: {
                                                        p: 0,
                                                        "&:last-child": { pb: 0 },
                                                        height: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                    }, children: [_jsx(TeamRow, { name: match.homeTeam.name, score: match.homeScore, isWinner: homeWins, isLoser: awayWins, isTbd: match.isTbd, primaryColour: match.homeTeam.primaryColour, secondaryColour: match.homeTeam.secondaryColour }), _jsx(Divider, {}), _jsx(TeamRow, { name: match.awayTeam.name, score: match.awayScore, isWinner: awayWins, isLoser: homeWins, isTbd: match.isTbd, primaryColour: match.awayTeam.primaryColour, secondaryColour: match.awayTeam.secondaryColour })] }) }));
                                            return match.id != null ? (_jsx(Link, { to: "/leagues/".concat(leagueId, "/seasons/").concat(seasonId, "/matches/").concat(match.id), style: { textDecoration: "none", color: "inherit" }, children: card }, match.id)) : (_jsx(Box, { children: card }, "tbd-".concat(col.round, "-").concat(matchIdx)));
                                        }) })] }), colIdx < columns.length - 1 && (_jsx(ConnectorLines, { matchesInRound: col.matches.length, totalHeight: bracketHeight }))] }, col.round)); }) }) })] }));
};
var ConnectorLines = function (_a) {
    var matchesInRound = _a.matchesInRound, totalHeight = _a.totalHeight;
    var pairCount = Math.floor(matchesInRound / 2);
    if (pairCount === 0)
        return _jsx(Box, { sx: { width: CONNECTOR_WIDTH, flexShrink: 0 } });
    var slotHeight = totalHeight / matchesInRound;
    return (_jsx(Box, { sx: { width: CONNECTOR_WIDTH, flexShrink: 0, position: "relative" }, children: _jsx("svg", { width: CONNECTOR_WIDTH, height: totalHeight, style: { display: "block" }, children: Array.from({ length: pairCount }).map(function (_, i) {
                var topIdx = i * 2;
                var botIdx = i * 2 + 1;
                // The card is centered within each slot via space-around.
                // The divider (center of the card) sits at slotCenter.
                var topY = slotHeight * topIdx + slotHeight / 2;
                var botY = slotHeight * botIdx + slotHeight / 2;
                var midY = (topY + botY) / 2;
                var midX = CONNECTOR_WIDTH / 2;
                return (_jsxs("g", { children: [_jsx("line", { x1: 0, y1: topY, x2: midX, y2: topY, stroke: "#bbb", strokeWidth: 1.5 }), _jsx("line", { x1: 0, y1: botY, x2: midX, y2: botY, stroke: "#bbb", strokeWidth: 1.5 }), _jsx("line", { x1: midX, y1: topY, x2: midX, y2: botY, stroke: "#bbb", strokeWidth: 1.5 }), _jsx("line", { x1: midX, y1: midY, x2: CONNECTOR_WIDTH, y2: midY, stroke: "#bbb", strokeWidth: 1.5 })] }, i));
            }) }) }));
};
